export interface NotificationSettingModel {
  appNotification: boolean
  emailNotification: boolean
}

export const settings: NotificationSettingModel = {
  appNotification: false,
  emailNotification: false,
}
